export default __webpack_public_path__ + "static/media/problema-03.4b493722.webp";